import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["text"]

  connect() {
    if (!this.canCopy()) {
      document.documentElement.classList.add('state--copy-not-supported')
    }
  }

  copy(event) {
    event.preventDefault()
    const button = event.currentTarget
    const text = this.textTarget.innerHTML

    if (!navigator.clipboard) {
      this.fallbackCopy(text, button)
      return
    }

    navigator.clipboard.writeText(text).then(() => {
      this.showCopiedState(button)
    }).catch(err => {
      console.error('Could not copy text: ', err)
    })
  }

  fallbackCopy(text, button) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    
    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showCopiedState(button)
      }
    } catch (err) {
      console.error('Fallback: Unable to copy', err)
      document.documentElement.classList.add('state--copy-not-supported')
    }
    
    document.body.removeChild(textArea)
  }

  showCopiedState(button) {
    button.classList.add("copied")
    setTimeout(() => {
      button.classList.remove("copied")
    }, 3000)
  }

  canCopy() {
    return document.queryCommandSupported('copy') || !!navigator.clipboard
  }
}
